import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import {
    displayableCashback,
    getMerchantCardUrl,
    renderPluralConditional,
    isMultiDiscount,
    isMultiDiscountOffline,
    hasCashback,
    hasOffline,
    hasCashbackOffline,
    hasOnAndOffCashback,
    hasEbonCashback
} from '../../../services/partner/utils';

import { STATIC_ROOT } from '../../../constants';
import { ENTERPRISE_CARD_NAME, ENTERPRISE_CARD_PARTNER_EBC_ID } from '../../../constants/ebon';

import SvgComponent from '../../SvgComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';

const renderUpTo = (partner, UPTO, isOffline) =>
    partner &&
    ((!isOffline && isMultiDiscount(partner)) || (isOffline && isMultiDiscountOffline(partner)))
        ? UPTO
        : '';

const mapStateToPropsResultCashback = state => ({
    REFUND: state.i18n.feature.partenaire.rembourse,
    UPTO: state.i18n.feature.partenaire.jusqua
});
const ResultCashback = connect(mapStateToPropsResultCashback)(({ partner, REFUND, UPTO }) =>
    hasCashback(partner) ? (
        <div className="value">
            <SvgComponent src={`${STATIC_ROOT}/picto-en-ligne.svg`} width="13" height="13" />
            {renderUpTo(partner, UPTO)}&nbsp;
            <span>
                {displayableCashback(
                    partner.mostDisplayableDiscountOnline.percent,
                    partner.mostDisplayableDiscountOnline.fixed
                )}
            </span>
            &nbsp;
            {renderPluralConditional(
                REFUND,
                () =>
                    partner &&
                    (partner.mostDisplayableDiscountOnline.fixed > 1 ||
                        partner.mostDisplayableDiscountOnline.percent > 1)
            )}
        </div>
    ) : null
);
const ResultCashbackOffline = connect(mapStateToPropsResultCashback)(({ partner, REFUND, UPTO }) =>
    hasOffline(partner) && hasCashbackOffline(partner) ? (
        <div className="value">
            <SvgComponent src={`${STATIC_ROOT}/picto-magasin.svg`} width="13" height="14" />
            {renderUpTo(partner, UPTO, true)}&nbsp;
            <span>
                {displayableCashback(
                    partner.mostDisplayableDiscountOffline.percent,
                    partner.mostDisplayableDiscountOffline.fixed
                )}
            </span>
            &nbsp;
            {renderPluralConditional(
                REFUND,
                () =>
                    partner &&
                    (partner.mostDisplayableDiscountOffline.fixed > 1 ||
                        partner.mostDisplayableDiscountOffline.percent > 1)
            )}
        </div>
    ) : null
);
const ResultCashbackEbon = connect(mapStateToPropsResultCashback)(({ partner, REFUND }) =>
    hasEbonCashback(partner) ? (
        <div className="value">
            <SvgComponent src={`${STATIC_ROOT}/picto-ebon.svg`} width="21" height="16" />
            <span>
                {displayableCashback(
                    partner.ebonDiscount.cashback.percent.value,
                    partner.ebonDiscount.cashback.fixed.value
                )}
            </span>
            &nbsp;
            {renderPluralConditional(
                REFUND,
                () =>
                    partner &&
                    (partner.ebonDiscount.cashback.fixed.value > 1 ||
                        partner.ebonDiscount.cashback.fixed.value > 1)
            )}
        </div>
    ) : null
);

const ResultCodeReduction = ({ partner }) =>
    partner.couponCount > 0 && (
        <React.Fragment>
            <SvgComponent src={`${STATIC_ROOT}/code-promo.svg`} width="18" height="22" />
            {partner.couponCount}
        </React.Fragment>
    );

const getPartnerName = partner => {
    const isEnterpriseCard = partner && partner.ebcId === ENTERPRISE_CARD_PARTNER_EBC_ID;
    return isEnterpriseCard ? ENTERPRISE_CARD_NAME : partner.name;
};

export const ResultComponent = ({ partner }) => (
    <li className={`resultat ${hasOnAndOffCashback(partner) ? 'large' : ''}`}>
        <div className="resultat-conteneur flex-container-h flex-center-alt">
            <div className="partnerName">
                {hasEbonCashback(partner) ? (
                    <LocalizedNavLink to={getMerchantCardUrl(partner, false, true)}>
                        {getPartnerName(partner)}
                    </LocalizedNavLink>
                ) : (
                    <LocalizedNavLink to={getMerchantCardUrl(partner, !hasCashback(partner))}>
                        {getPartnerName(partner)}
                    </LocalizedNavLink>
                )}
            </div>
            <div className="resultat-valeur">
                {hasEbonCashback(partner) ? (
                    <React.Fragment>
                        <LocalizedNavLink to={getMerchantCardUrl(partner, false, true)}>
                            <ResultCashbackEbon partner={partner} />
                        </LocalizedNavLink>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <LocalizedNavLink to={getMerchantCardUrl(partner)}>
                            <ResultCashback partner={partner} />
                        </LocalizedNavLink>
                        {hasOnAndOffCashback(partner) && (
                            <React.Fragment>
                                <MediaQuery query="(min-width: 769px)">
                                    {matches => (matches ? <br /> : '')}
                                </MediaQuery>
                            </React.Fragment>
                        )}
                        <LocalizedNavLink to={getMerchantCardUrl(partner, true)}>
                            <ResultCashbackOffline partner={partner} />
                        </LocalizedNavLink>
                    </React.Fragment>
                )}
            </div>
            <div className="coupon">
                <LocalizedNavLink to={getMerchantCardUrl(partner)}>
                    <ResultCodeReduction partner={partner} />
                </LocalizedNavLink>
            </div>
        </div>
    </li>
);



// WEBPACK FOOTER //
// ./src/components/header/search/ResultComponent.js